
<div class="modal-dialog confirm-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Select Partner</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col">
          <label class="required">Partner</label>
          <select class="form-control" [(ngModel)]="partnerSelected" name="partnerSelected">
            <option *ngFor="let partner of partners" [ngValue]="partner.id">{{ partner.name }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" type="button" (click)="selectPartner()">Select & Send</button>
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>